export const trackAdobeAnalyticEvent = (eventData) => {
    window._satellite?.track("export_report", eventData);
}